'use client'

import React from 'react'
import { ProfileEditor } from '@/clients/components/organisms/ProfileEditor'
import { GlobalNav } from '@/components/organisms/GlobalNav'
import { AppBanner } from '@/clients/components/organisms/Banner/AppBanner'
import { Footer } from '@/clients/components/molecules/Footer'
import { GameTitle } from '@/clients/models/types/GameTitle'
import { useViewEvent } from '@/clients/firebase/analytics'

type Props = {
  title: GameTitle
  creator: string | null
}

const MeProfilesCreateClient: React.FC<Props> = ({ title, creator }) => {
  useViewEvent('MyProfileCreateView', { title, creator })
  
  return (
    <>
      <GlobalNav />
      <AppBanner />
      <ProfileEditor gameTitle={title} />
      <Footer />
    </>
  )
}

export default MeProfilesCreateClient